// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"6cb5dba4","287":"3a401f7d","312":"f27cd297","990":"8e20ae9c"}[chunkId] + ".chunk.css";
};